import React from 'react';
import { Heart } from 'lucide-react';
import TeamLoginPortal from '@/components/TeamLoginPortal';

const CampaignTeamLogin = () => (
  <TeamLoginPortal
    system="campaign"
    title="Campaign Workspace"
    subtitle="Sign in to chase pledges, manage donors, and run your campaigns."
    icon={Heart}
    accent="emerald"
    membershipCheckUrl="/campaigns/team/mine"
    defaultLanding="/my-campaigns"
  />
);

export default CampaignTeamLogin;
